// extracted by mini-css-extract-plugin
export default {"root":"notfound_root__HJMp6","link":"notfound_link__NQW0x","glitch":"notfound_glitch__Ik6CK","glitch-effect":"notfound_glitch-effect__eFz8d"};